import React, { useState } from 'react';
import {
    Box,
    Button,
    Select,
    TextField,
    MenuItem,
    FormControl,
    FormControlLabel,
    InputLabel,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography
} from '@mui/material';
import PropTypes from 'prop-types';

const AddDialog = (props) => {
    const [groupName, setGroupName] = useState('');
    const [description, setDescription] = useState('');
    const [parentId, setParentId] = useState(null);
    // const [isParent, setIsParent] = useState(false);

    const handleChangeParentId = (e) => {
        setParentId(Number(e.target.value));
    };

    // const handleChangeIsParent = (e) => {
    //     setIsParent(e.target.checked);
    // };

    return (
        <Dialog open={true} onClose={props.onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>Add New Group</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField sx={{ width: '100%' }} label="Group Name" value={groupName} onChange={(e) => setGroupName(e.target.value)} />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{ width: '100%' }}
                        label="Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </Box>
                <Box>
                    {/*<FormControlLabel*/}
                    {/*    control={<Checkbox checked={isParent} onChange={handleChangeIsParent} color="primary" />}*/}
                    {/*    label="Is Parent"*/}
                    {/*/>*/}
                    {/*{!isParent &&*/}
                    {/*    (props.tree.length === 0 ? (*/}
                    {/*        <Typography>It should be a parent</Typography>*/}
                    {/*    ) : (*/}
                    <FormControl sx={{ width: '100%', mt: 2 }}>
                        <InputLabel>Parent Group</InputLabel>
                        <Select label="Parent Group" onChange={handleChangeParentId} value={parentId}>
                            {/* <MenuItem value={0}>(root)</MenuItem> */}
                            {props.tree
                                // .filter((node) => node.droppable === true)
                                .map((node) => (
                                    <MenuItem key={node.id} value={node.id}>
                                        {node.name}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                    {/*))}*/}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Cancel</Button>
                <Button
                    disabled={groupName === '' || parentId === null}
                    onClick={() => props.onSubmit({ groupName, description, parentId })}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

AddDialog.propTypes = {
    props: PropTypes.any
};

export default AddDialog;
